// extracted by mini-css-extract-plugin
export default {"aiBadge":"AiBadge_aiBadge__wYj7J"};